import { createElementFromString } from '~/utils/string'
import type { CreateCustomTooltip } from './definitions'

export const createTooltipElement = () => {
  return createElementFromString(`
    <div id="chartjs-tooltip" class="!p-4 overflow-y-auto" style="max-height: 210px;">
      <div></div>
    </div>
  `)
}

export const getPositionTooltip = ({ chart, tooltip, width }) => {
  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas
  const { xAlign, yAlign, caretX, caretY, x } = tooltip
  const top = positionY + 10 + caretY
  const space = 8 // The caret plus one pixel for some space, you can increase it.

  let left = positionX + window.scrollX + caretX

  if (xAlign === 'left') {
    left += width / 2 - x - space / 2
    if (yAlign === 'center') {
      left += space * 2
    }
    return { top, left }
  }

  if (xAlign === 'right') {
    left -= width / 2
    if (yAlign === 'center') {
      left -= space
    } else {
      left += space
    }
    return { top, left }
  }

  if (xAlign === 'center' && screen.width <= 550) {
    left = left / 2 + 50
    return { top, left }
  }

  return { top, left }
}

export const createCustomTooltip: CreateCustomTooltip = (context, cb) => {
  const { chart, tooltip } = context
  let tooltipEl = chart.canvas.parentNode.querySelector('div')
  tooltipEl = tooltipEl ? tooltipEl : createTooltipElement()
  chart.canvas.parentNode.appendChild(tooltipEl)

  tooltipEl.innerHTML = ''
  if (tooltip.body) {
    const content = cb(context)
    tooltipEl.append(...content)
  }

  const { width } = tooltipEl.getBoundingClientRect()
  const { top, left } = getPositionTooltip({ chart, tooltip, width })

  // Display, position, and set styles for font
  tooltipEl.style.left = `${left}px`
  tooltipEl.style.top = `${top}px`
  tooltipEl.style.fontFamily = tooltip.options.bodyFont.string
  tooltipEl.style.padding =
    tooltip.options.padding.bottom + 'px ' + tooltip.options.padding.left + 'px'
  tooltipEl.style.pointerEvents = 'auto'
  return tooltipEl
}
